module.exports = __webpack_public_path__ + "img/using-the-animation.9b7b50ad.png";